import React, { Component } from 'react';
import PropTypes from 'prop-types';
import SvgIcon from '@material-ui/core/SvgIcon';
import Logo from './images/logo-theme2019.svg';
class GabrielCircleIcon extends Component {
  render() {
    return (
       <img src={Logo} style = {window.innerWidth > 768 ? {height: '15px', display: 'flex', width: '100%', justifyContent: 'center'} : {height: '15px', display: 'flex', width: '100%', justifyContent: 'center'}} />
    );
  }
}

GabrielCircleIcon.propTypes = {
  classes: PropTypes.object,
};

export default GabrielCircleIcon;



// WEBPACK FOOTER //
// ./src/GabrielCircleIcon.js